export enum AutomotiveAftermarketProfileEndpoint {
  Base = '/automotive-aftermarket',
  Profiles = '/profiles',
  Clone = '/clone',
  Profile = '/profile',
  Report = '/report',
  Fields = '/fields',
}
